import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/App.css';
import './styles/BackButton.css';
import './styles/Header.css';
import './styles/SearchPages.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // Only log in development
        if (process.env.NODE_ENV === 'development') {
          console.log('Service Worker registered:', registration);
        }
      })
      .catch((error) => {
        // Always log errors
        console.error('Service Worker registration failed:', error);
      });
  });
}